import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { User } from '../../_models/user.model';

@Injectable({ providedIn: 'root' })
export class UserService {

  constructor(private http: HttpClient) {
  }

  createUser(attributes: CognitoUserAttribute[]) {

    const user = new User();

    // Populate the attributes from Idp.
    for (const attribute of attributes) {
      switch (attribute.getName()) {
        case 'preferred_username':
          user.userName = attribute.getValue();
          break;
        case 'given_name':
          user.firstName = attribute.getValue();
          break;
        case 'family_name':
          user.lastName = attribute.getValue();
          break;
        case 'custom:memberof':
          const memberOf = attribute.getValue();
          if (memberOf) {
            user.roleTypeCode = memberOf.substr(memberOf.indexOf('=') + 1,
            memberOf.indexOf(',') - 3);
          }
          break;
        case 'custom:etsguid':
          user.guid = attribute.getValue();
          break;
        case 'email':
          user.emailAddress = attribute.getValue();
          break;
      }
    }
    console.log('User: ', user);
    return user;
  }
}
